export default class MessageFormat {
    constructor() {}

    isObject (obj) {
        return obj !== null && typeof obj === 'object'
    }

    parse (format) {
        var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
        var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;
        var tokens = [];
        var position = 0;

        var text = '';
        while (position < format.length) {
            var char = format[position++];
            if (char === '{') {
                if (text) {
                    tokens.push({ type: 'text', value: text });
                }

                text = '';
                var sub = '';
                char = format[position++];
                while (char !== undefined && char !== '}') {
                    sub += char;
                    char = format[position++];
                }
                var isClosed = char === '}';

                var type = RE_TOKEN_LIST_VALUE.test(sub)
                    ? 'list'
                    : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
                        ? 'named'
                        : 'unknown';
                tokens.push({ value: sub, type: type });
            } else if (char === '%') {
                // when found rails i18n syntax, skip text capture
                if (format[(position)] !== '{') {
                    text += char;
                }
            } else {
                text += char;
            }
        }

        text && tokens.push({ type: 'text', value: text });

        return tokens
    }

    compile (tokens, values) {
        var compiled = [];
        var index = 0;

        var mode = Array.isArray(values)
            ? 'list'
            : this.isObject(values)
                ? 'named'
                : 'unknown';
        if (mode === 'unknown') { return compiled }

        while (index < tokens.length) {
            var token = tokens[index];
            switch (token.type) {
                case 'text':
                    compiled.push(token.value);
                    break;
                case 'list':
                    compiled.push(values[parseInt(token.value, 10)]);
                    break;
                case 'named':
                    if (mode === 'named') {
                        compiled.push((values)[token.value]);
                    } else {
                        if (process.env.NODE_ENV !== 'production') {
                            warn(("Type of token '" + (token.type) + "' and format of value '" + mode + "' don't match!"));
                        }
                    }
                    break;
                case 'unknown':
                    if (process.env.NODE_ENV !== 'production') {
                        warn("Detect 'unknown' type of token!");
                    }
                    break
            }
            index++;
        }

        return compiled
    }
}

